import { blankSlab, canSetIntendedUse, createRow } from './inventoryModel.mjs';

export function markSubmissionRow(row, number) {
  const label = `ACE grading return · submission ${number}`;
  const notes = row.draft.notes.split('\n').includes(label) ? row.draft.notes : [row.draft.notes, label].filter(Boolean).join('\n');
  if (notes.length > 2000) return row;
  return { ...row, aceSubmission: number, draft: { ...row.draft, notes }, touched: { ...row.touched, notes: true } };
}

export function addSubmissionRows(current, submission) {
  const rows = [...current], addedCerts = [], reusedCerts = [], skippedCerts = [], fresh = [];
  const indices = new Map(rows.map((row, index) => [row.slab.certNumber, index]));
  for (const cert of submission.certs) {
    const index = indices.get(cert);
    if (index !== undefined) {
      const row = rows[index];
      if (!canSetIntendedUse(row) || row.saving || row.saveConflict || row.saveUncertain || row.remoteMissing || row.manualPurchase || (row.aceSubmission && row.aceSubmission !== submission.number)
        || [row.draft.notes, `ACE grading return · submission ${submission.number}`].join('\n').length > 2000) { skippedCerts.push(cert); continue; }
      rows[index] = { ...markSubmissionRow(row, submission.number), intake: true, selected: true };
      reusedCerts.push(cert);
    } else {
      // A grading return is not a new purchase: do not inherit paid/date/supplier
      // or manual-purchase defaults from the current receiving batch.
      fresh.push({ ...createRow(blankSlab(cert), { intake: true, defaults: { batchId: `ace-submission-${submission.number}` } }), aceSubmission: submission.number });
      addedCerts.push(cert);
    }
  }
  return { rows: [...fresh.reverse(), ...rows], addedCerts, reusedCerts, skippedCerts };
}
